import { CLEAR_USER_INFO, SET_USER_INFO } from '../constants/user';

export interface IUserInfo {
  walletAddress?: string;
  currentChain?: number;
}

const initialStates: IUserInfo = {};

export const userReducer = (state = initialStates, action: any) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_USER_INFO:
      return initialStates;

    default:
      return state;
  }
};
